module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title":"AI 착용샷 안내","description_title":"실제 착용한 사진을 업로드해보세요.","description_content":"사진을 첨부하면 AI 분석을 통해 착용샷 여부를 판독합니다.\\n상품을 착용한 상태로 신체 부위 (눈, 코, 입, 팔, 다리, 허리 등)가\\n노출된 사진을 업로드해주세요.","disclaimer":"*AI 분석 모델로 판독하며, 분석에 오차가 발생할 수 있습니다."}}')
  delete Component.options._Ctor
}
